export type Culture = "he-il" | "en-us"
export type GalleryItemWithAlts = {
  imageOrVideoSelectorMobaile?: string
  imageOrVideoSelectorMobaileAlt?: string
  imageOrVideoSelsctor?: string
  imageOrVideoSelsctorAlt?: string
}

export type FacilityItem = {
  facilityName: string
  icon: string | null
}
export type BusLineItem = {
  title: string
}
export type UmbracoMapType = {
  address?: {
    coordinates?: {
      latitude?: number
      longitude?: number
    }
  }
}

export type UmbracoImageType = {
  altText?: null | string
  url: string
}

export type PortItem = {
  url: string
  portName: string
  desktopImage: UmbracoImageType | null
  mobileImage: UmbracoImageType | null
  mapDesktopImage: string | null
  mapMobileImage: string | null
  facilityList: FacilityItem[]
  busLines: BusLineItem[]
  parkingName: string
  parkingAddress: string
  wazeLink: string
  address: string
  map: UmbracoMapType | null
  mapName: string
  upperTextOurLocation?: string
  hostLocationName?: string
  portFacilities: FacilityContent[]
  node: any
}

export type PortArticleItem = {
  url: string
  title: string
  description: string
  date: string
  image: string | null
  node: any
}

export type FacilityContent = {
  id: string
  url: string
  facilityName: string
  facilityType: string
  image: string | null
  address: string
  amountOfPeople: string
  hoverButton: { name: string; url: string; target?: string } | null
  hoverText: string
  price: string
  button: { name: string; url: string; target?: string } | null
  description: string
  parentPortUrl: string
  hostResourceId?: number
  node: any
}

export type PortLocation = {
  lat: number
  lng: number
  port: PortItem
}

/**
 * Extracts coordinates from a PortItem's map field
 * Returns { lat, lng } if both latitude and longitude exist, otherwise null
 */
export function getPortCoordinates(port: PortItem): { lat: number; lng: number } | null {
  const coords = port.map?.address?.coordinates
  if (coords?.latitude != null && coords?.longitude != null) {
    return { lat: coords.latitude, lng: coords.longitude }
  }
  return null
}

/**
 * Filters ports to only those with valid coordinates and returns PortLocation array
 */
export function getPortsWithCoordinates(ports: PortItem[]): PortLocation[] {
  return ports
    .map((port) => {
      const coords = getPortCoordinates(port)
      if (coords) {
        return { ...coords, port }
      }
      return null
    })
    .filter((item): item is PortLocation => item !== null)
}
